<template>
  <div class="tech-layout" :class="{'video-screen-locked': videoScreenLocked}">
    <vision-header />
    <div id="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import VisionHeader from "../components/header/VisionHeader";
  import {initializeSocket} from "../services/socket/socket";

  export default {
    components: {VisionHeader},
    data: () => {
      return {
        isProduction: process.env.NODE_ENV === 'production'
      }
    },

    computed: {
      ...mapState({
        self: state => state.auth.self,
        videoScreenLocked: state => state.global.videoScreenLocked
      })
    },

    methods: {
      logoutUser() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/log-in');
      }
    },
    created() {
      initializeSocket()
    }
  }
</script>

<style lang="scss">
  @import "TechLayout";
</style>
